import React from 'react';

/**
 * Big Golf Divino official logo for hero sections.
 */
export default function BigLogo({ className = '' }) {
  return (
    <div className={`flex justify-center ${className}`}>
      <img
        src="/brand/golfdivino-logo-full.png"
        alt="Golf Divino · Business Club"
        className="h-48 md:h-64 lg:h-80 w-auto object-contain"
        draggable={false}
      />
    </div>
  );
}
